import SmiV2BaseApi from './smiV2BaseApi';


export default class SmiV2YouTube extends SmiV2BaseApi {
  unbindBroadcast({ user, token, broadcastId }) {
    return fetch(`${this.smiv2ApiEndpoint}/v2/users/${user}/${this.serviceName}/broadcasts/${broadcastId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        token,
      },
    });
  }

  deleteBroadcast({ user, token, broadcastId }) {
    return fetch(`${this.smiv2ApiEndpoint}/v2/users/${user}/${this.serviceName}/broadcasts/${broadcastId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        token,
      },
    });
  }

  deleteStream({ user, token, streamId }) {
    return fetch(`${this.smiv2ApiEndpoint}/v2/users/${user}/${this.serviceName}/streams/${streamId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        token,
      },
    });
  }
}
